import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9723231c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sort" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sort_title\" data-v-9723231c><span class=\"sort_title_text\" data-v-9723231c>あなたにとっての</span><span class=\"sort_title_text\" data-v-9723231c>メインキャリアから順に</span><span class=\"sort_title_text\" data-v-9723231c>並べてください</span></div><div class=\"sort_text\" data-v-9723231c>をドラッグしてください</div>", 2)
const _hoisted_4 = { class: "sort_block" }
const _hoisted_5 = { class: "sort_block_item" }
const _hoisted_6 = { class: "sort_block_item_label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sort_block_item_icon" }, null, -1))

import { PropType, ref, computed, watchEffect } from 'vue';
import draggable from 'vuedraggable';
import { CheckboxListType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListSort',
  props: {
  list: {
    type: Array as PropType<CheckboxListType[]>,
    default() {
      return [];
    },
  },
  modelValue: {
    type: Array as PropType<string[]>,
    default() {
      return [];
    },
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props


const value = ref(
  props.modelValue.map((item, index) => {
    return { index: index, value: item };
  })
);



watchEffect(() => {
  const newValue = value.value.map((item) => {
    return item.value;
  });
  emits('update:modelValue', newValue);
});

// 選択した職種の値に該当するテキストを設定する
const occupationTextList = computed(() => {
  return props.list.map((i) => i.children?.map((j) => j.children)).flat(2);
});
const getSelectedOccupationText = (ocupctgId: string) => {
  return occupationTextList.value.find((i) => {
    return i?.value === ocupctgId;
  })?.label;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(draggable), {
        list: value.value,
        "item-key": "name",
        animation: "100",
        "ghost-class": "ghost",
        tag: "ul"
      }, {
        item: _withCtx(({ element }) => [
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(getSelectedOccupationText(element.value)), 1),
            _hoisted_7
          ])
        ]),
        _: 1
      }, 8, ["list"])
    ])
  ]))
}
}

})